/* eslint-disable @typescript-eslint/indent */
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { FS_SUGGESTED_EXPECTED_EXPENSES, FS_SUGGESTED_TOTAL_COMMITMENT } from "../../pojo/fund-strategy-constants";
import { FundStrategyMetricsNames } from "../../pojo/fund-strategy-enums";
import { FSFundMetrics, FSFundMetricsDTO, FSFundMetricsMiniDTO } from "../../pojo/fund-strategy-export-classes";
import { FSFundMetricsGroup } from "../../pojo/fund-strategy-export-types";

@Component({
  selector: 'app-fund-strategy-fund-metrics',
  templateUrl: './fund-strategy-fund-metrics.component.html',
  styleUrls: ['./fund-strategy-fund-metrics.component.scss'],
})

export class FundStrategyFundMetricsComponent implements OnChanges {
  @Input() metricsData = new FSFundMetrics();
  @Input() isModelBlocked = false;
  @Output() inputsSaveEmitter: EventEmitter<FSFundMetricsMiniDTO> = new EventEmitter<FSFundMetricsMiniDTO>();

  metrics = {
    name: FundStrategyMetricsNames,
  };

  metricsForm: FSFundMetricsGroup;

  constructor(private fb: FormBuilder) {};


  ngOnChanges(): void {
    if (this.isModelBlocked) {
      this.metricsData.totalCommitment = FS_SUGGESTED_TOTAL_COMMITMENT;
      this.metricsData.expectedExpenses = FS_SUGGESTED_EXPECTED_EXPENSES;
    }
    this.initMetricsForm(this.metricsData);
  }

  calculateMetrics(value: number, metric: FundStrategyMetricsNames): void {
    const formValues = this.metricsForm.getRawValue();

    const metricsData = new FSFundMetricsDTO(
      formValues.totalCommitment,
      formValues.expectedExpenses,
      formValues.investment,
      formValues.proceeds,
    );

    switch (metric) {
      case FundStrategyMetricsNames.totalCommitment:
        metricsData.totalCommitment = value;
        break;

      case FundStrategyMetricsNames.expectedExpenses:
        metricsData.expectedExpenses = value;
        break;

      case FundStrategyMetricsNames.expectedExpensesPcnt:
        metricsData.expectedExpenses = (value * metricsData.totalCommitment) / 100;
        break;
    }

    const tvpi = this.calculateTvpi(metricsData);
    const gain = metricsData.proceeds - metricsData.investment - metricsData.expectedExpenses;
    const expectedExpensesPcnt = (metricsData.expectedExpenses / metricsData.totalCommitment) * 100;


    this.metricsForm.patchValue({
      tvpi,
      gain,
      expectedExpensesPcnt,
      expectedExpenses: metricsData.expectedExpenses,
      unAllocatedCommitment: metricsData.unAllocatedCommitment,
    });
  }

  calculateTvpi(metricsData: FSFundMetricsDTO): number {
    const { proceeds, unAllocatedCommitment, expectedExpenses, investment, totalCommitment } = metricsData;

    const denominator = unAllocatedCommitment > 0
                        ? (Number(expectedExpenses) + investment)
                        : totalCommitment;
    return Math.abs(proceeds / denominator);
  }

  emitSaveInputs() {
    const metricsForm = this.metricsForm.getRawValue();
    const miniDto = new FSFundMetricsMiniDTO(
      metricsForm.totalCommitment,
      metricsForm.expectedExpenses,
    );
    this.inputsSaveEmitter.emit(miniDto);
  }

  initMetricsForm(metricsData: FSFundMetricsDTO) {
    this.metricsForm = this.fb.group({
      totalCommitment: new FormControl({ value: metricsData.totalCommitment, disabled: this.isModelBlocked }),
      unAllocatedCommitment: new FormControl({ value: metricsData.unAllocatedCommitment, disabled: true }),
      expectedExpenses: new FormControl({ value: metricsData.expectedExpenses, disabled: this.isModelBlocked }),
      expectedExpensesPcnt: new FormControl({ value: metricsData.expectedExpensesPcnt, disabled: this.isModelBlocked }),
      investment: new FormControl({ value: metricsData.investment, disabled: true }),
      proceeds: new FormControl({ value: metricsData.proceeds, disabled: true }),
      gain: new FormControl({ value: metricsData.gain, disabled: true }),
      tvpi: new FormControl({ value: metricsData.tvpi, disabled: true }),
    });
  }

}
